import { ElevatedSystemWallet } from 'core/contexts/user-settings';
import {
    ELEVATED_SYSTEM_WALLET_KEY,
    USER_SETTINGS_KEY,
} from '../contexts/user-settings/user-settings-helper';

const getUserSettings = (): any => {
    return JSON.parse(localStorage.getItem(USER_SETTINGS_KEY) as string) ?? {};
};

const getElevatedSystemWallet = (): ElevatedSystemWallet => {
    return getUserSettings()[ELEVATED_SYSTEM_WALLET_KEY];
};

export const getElevatedSystemWalletId = (): string => {
    const elevatedUserId: string | undefined = getElevatedSystemWallet()?.id;
    const elevated: boolean = getElevatedSystemWallet()?.elevated ?? false;

    return (elevated && elevatedUserId) || '';
};
